/**
 * Human label for a page from the sidebar navigation config (same names the
 * user sees in the menu). Undefined when the path isn't in the menu.
 */

import { findActiveSubItem, findParentNavItem } from "@/lib/config/navigationConfig";

export function getPageLabel(pathname: string): string | undefined {
  try {
    return findActiveSubItem(pathname)?.name ?? findParentNavItem(pathname)?.name ?? undefined;
  } catch {
    return undefined;
  }
}
